import api from "./api";

export const saleService = {
  // Get user's sale history
  getUserSales: async () => {
    const response = await api.get("/sales");
    return response.data.data.sales;
  },

  // Create sale
  createSale: async (saleData) => {
    const response = await api.post("/sales", saleData);
    return response.data.data.sale;
  },

  // Get sale by ID
  getSaleById: async (saleId) => {
    const response = await api.get(`/sales/${saleId}`);
    return response.data.data.sale;
  },

  // Get all sales (admin only)
  getAllSales: async () => {
    const response = await api.get("/admin/sales");
    return response.data.data.sales;
  },

  // Update sale status (admin only)
  updateSaleStatus: async (saleId, status) => {
    const response = await api.patch(`/sales/${saleId}/status`, { status });
    return response.data.data.sales;
  },
};
